import styled from 'styled-components'
import MUITableRow from '@material-ui/core/TableRow'

const TableRow = styled(MUITableRow)`
  &.disabled {
    background-color: ${({ theme }) => theme.palette.grey[100]};
    td {
      color: ${({ theme }) => theme.palette.text.disabled};
    }
  }
`

export default TableRow
